import { render, staticRenderFns } from "./ValidarCodigoAtendimento.vue?vue&type=template&id=40c6c840&"
import script from "./ValidarCodigoAtendimento.vue?vue&type=script&lang=js&"
export * from "./ValidarCodigoAtendimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports